import { useCallback } from 'react'

import { useSelector } from 'react-redux'

import { getUserId } from 'src/Redux/auth-process/userSlice/selectors'
import {
  createCampaignEvent,
  createdCampaignEvent,
} from 'src/Helpers/TagManager'
import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'
import {
  useFirstCampaignCreationStartMutation,
  useNewCampaignCreationStartMutation,
} from 'src/Redux/analyticsApi'
import { getIsAuth } from 'src/Redux/auth-process/credentialsSlice/selectors'
import { getAmountOfCampaigns } from 'src/Redux/campaignList-process'

export const useCreateCampaignEvents = (): {
  createCampaignEventHandler: ({
    campaignId,
  }: {
    campaignId: string | number
  }) => void

  createdTikTokCampaignEventHandler: ({
    campaignId,
    trackTiktokId,
  }: {
    campaignId: string | number
    trackTiktokId?: string | number
  }) => void

  createdSpotifyCampaignEventHandler: ({
    campaignId,
    spotifyTrackId,
  }: {
    campaignId: string | number
    spotifyTrackId: string | number
  }) => void

  campaignCreationStartMpEventHandler: ({
    platformType,
  }: {
    platformType: CampaignPlatformTypeEnum
  }) => void
} => {
  const [firstCampaignCreationStart] = useFirstCampaignCreationStartMutation()
  const [newCampaignCreationStart] = useNewCampaignCreationStartMutation()
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)
  const userID = useSelector(getUserId)
  const isAuth = useSelector(getIsAuth)

  const referrerUrl = document.referrer
  const urlParams = new URLSearchParams(window.location.search)
  const utmCampaign = urlParams?.get('utm_campaign')
  const utmContent = urlParams?.get('utm_content')
  const utmMedium = urlParams?.get('utm_medium')
  const utmSource = urlParams?.get('utm_source')
  const utmTerm = urlParams?.get('utm_term')

  const campaignNumber = amountOfCampaigns + 1

  const createCampaignEventHandler = ({
    campaignId,
  }: {
    campaignId: string | number
  }): void => {
    // CreatedCampaign GTM event
    createCampaignEvent(String(userID), String(campaignId))
  }

  const createdTikTokCampaignEventHandler = ({
    campaignId,
    trackTiktokId,
  }: {
    campaignId: string | number
    trackTiktokId?: string | number
  }): void => {
    // created_campaign GTM event
    campaignNumber &&
      createdCampaignEvent({
        campaignNumber,
        campaignId,
        isFirstCampaign: false,
        platformName: CampaignPlatformTypeEnum.TIKTOK,
        trackId: trackTiktokId || campaignId,
        userId: String(userID),
      })
  }

  const createdSpotifyCampaignEventHandler = ({
    campaignId,
    spotifyTrackId,
  }: {
    campaignId: string | number
    spotifyTrackId: string | number
  }): void => {
    campaignId &&
      campaignNumber &&
      createdCampaignEvent({
        campaignNumber,
        campaignId,
        isFirstCampaign: false,
        platformName: CampaignPlatformTypeEnum.SPOTIFY,
        trackId: spotifyTrackId,
        userId: String(userID),
      })
  }

  const campaignCreationStartMpEventHandler = useCallback(
    ({ platformType }: { platformType: CampaignPlatformTypeEnum }): void => {
      !isAuth
        ? void firstCampaignCreationStart({
            campaignPlatform: platformType,
            utmCampaign: utmCampaign || '',
            utmContent: utmContent || '',
            utmMedium: utmMedium || '',
            utmSource: utmSource || '',
            utmTerm: utmTerm || '',
            referrerUrl,
          })
        : void newCampaignCreationStart({
            campaignPlatform: platformType,
            campaignType: CampaignTypeEnum.BASIC,
          })
    },
    [
      isAuth,
      firstCampaignCreationStart,
      newCampaignCreationStart,
      utmCampaign,
      utmContent,
      utmMedium,
      utmSource,
      utmTerm,
      referrerUrl,
    ],
  )
  return {
    createCampaignEventHandler,
    createdTikTokCampaignEventHandler,
    createdSpotifyCampaignEventHandler,
    campaignCreationStartMpEventHandler,
  }
}
